<template>
  <div class="active_table">
    <div class="toolbar">
      <div class="bg_tool">
        <div class="search">
          <i-input prefix="ios-search" placeholder="输入查询条件" v-model="search.name" style="width: auto" />
          <i-button type="default" style="margin-left: 1em" @click="getData">搜索</i-button>
        </div>
        <div class="active">
          <i-button type="primary" @click="addData">添加</i-button>
          <i-button type="error" style="margin-left: 1em">批量删除</i-button>
        </div>
      </div>
    </div>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="企业名称：" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入企业名称"></i-input>
        </FormItem>
        <FormItem label="企业别名：" prop="alias">
          <i-input v-model="formValidate.alias" placeholder="输入企业别名"></i-input>
        </FormItem>
        <FormItem label="企业地址：" prop="address">
          <i-input v-model="formValidate.address" placeholder="输入企业地址"></i-input>
        </FormItem>

        <FormItem label="经度：" prop="imgUrlMpX">
          <i-input v-model="formValidate.imgUrlMpX" type="number" placeholder="输入经度"></i-input>
        </FormItem>

        <FormItem label="纬度：" prop="imgUrlMpY">
          <i-input v-model="formValidate.imgUrlMpY" type="number" placeholder="输入纬度"></i-input>
        </FormItem>

        <FormItem label="配图：" prop="imgUrl">
          <div class="form_upload">
            <LoadImg :imgUrl="formValidate.imgUrl" @close="imgLoadDel('imgUrl')" @success="imgLoadSuccess($event)">
            </LoadImg>
          </div>
        </FormItem>

        <FormItem label="Logo：">
          <div class="form_upload">
            <LoadImg :imgUrl="formValidate.logoImgUrl" @close="imgLoadDel('logoImgUrl')"
              @success="logoImgLoadSuccess($event)"></LoadImg>
          </div>
        </FormItem>

        <FormItem label="企业法人：" prop="corporate">
          <i-input v-model="formValidate.corporate" placeholder="输入企业法人"></i-input>
        </FormItem>

        <FormItem label="联系电话：" prop="contactTel">
          <i-input v-model="formValidate.contactTel" placeholder="输入联系电话"></i-input>
        </FormItem>

        <FormItem label="所属行业:" prop="industriesId">
          <Select v-model="formValidate.industriesId" @on-change="getIndustriesSelected()" placeholder="选择所属行业">
            <Option v-for="item in industriesList" :key="item.value" :value="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="所属区域:" prop="groupId">
          <Select v-model="formValidate.groupId" @on-change="getGroupSelected()" placeholder="选择所属区域">
            <Option v-for="item in groupList" :key="item.value" :value="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- <FormItem label="设备套数：" prop="deviceSets">
          <i-input
            v-model="formValidate.deviceSets"
            type="number"
            placeholder="输入设备套数"
          ></i-input>
        </FormItem> -->
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{
          modal.title
        }}</i-button>
        <i-button style="margin-left: 1em" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.toolbar {
  width: 100%;
  padding: 3em 1em 1em 1em;
  height: 7.5em;

  .bg_tool {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0.2em 1em;
    border: 1px solid #ccc;
    border-radius: 3.5px;
    justify-content: space-between;
    align-items: center;
  }
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
}
</style>

<script>
import LoadImg from "../../../components/Load_img.vue";
import { validate } from "../../../util/common/validate"; // 验证工具
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      //所属环保所分组数据
      groupList: [],
      //所属行业
      industriesList: [],
      // 表格属性
      table: {
        // 列
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "企业名",
            key: "name",
            align: "center",
          },
          {
            title: "厂区地图",
            key: "imgUrl",
            align: "center",
            render(h, params) {
              return h(
                "div",
                {
                  style: {
                    height: "50px",
                    overflow: "hidden",
                  },
                },
                [
                  h("vImage", {
                    props: {
                      imgUrl: params.row.imgUrl,
                    },
                  }),
                ]
              );
            },
          },
          {
            title: "地址",
            key: "address",
            align: "center",
          },
          {
            title: "企业法人",
            key: "corporate",
            align: "center",
          },
          {
            title: "联系电话",
            key: "contactTel",
            align: "center",
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          name: params.row.name, // 企业名称
                          imgUrl: params.row.imgUrl, // 企业厂区图片
                          address: params.row.address, // 企业地址
                          corporate: params.row.corporate, // 企业法人
                          contactTel: params.row.contactTel, // 企业电话
                          imgUrlMpX: params.row.imgUrlMpX, // 经度
                          imgUrlMpY: params.row.imgUrlMpY, // 纬度
                          logoImgUrl: params.row.logoImgUrl,
                          alias: params.row.alias, // 别名
                          groupId: params.row.groupId, // 环保所分组
                          industriesId: params.row.industriesId, // 所属行业
                          // deviceSets: params.row.deviceSets + "", // 设备套数
                        };
                        this.$set(
                          this.formValidate,
                          "imgUrl",
                          params.row.imgUrl
                        );
                        //console.log(this.formValidate.imgUrl);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        // 数据
        data: [],
        // 总数
        total: 0,
        // 加载开关
        loading: false,
        // 页码
        pageCurrent: 1,
        pageSize: 10,
      },
      // 查询属性
      search: {
        name: null,
      },
      // 对话框属性
      modal: {
        show: false,
        title: null,
      },
      // 表单数据
      formValidate: {
        name: "", // 企业名称
        imgUrl: "", // 企业厂区图片
        address: "", // 企业地址
        corporate: "", // 企业法人
        contactTel: "", // 企业电话
        imgUrlMpX: null, // 企业经度
        imgUrlMpY: null, // 企业纬度
        logoImgUrl: "", // logo
        alias: "", // 别名
        // deviceSets: "", //设备套数
      },
      // 验证
      ruleValidate: {
        imgUrl: [{ required: true, message: "不能为空", trigger: "blur" }],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        address: [{ required: true, message: "不能为空", trigger: "blur" }],
        corporate: [{ required: true, message: "不能为空", trigger: "blur" }],
        contactTel: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("不能为空");
              } else if (!validate.phone(value)) callback("手机号格式错误");
              else callback();
            },
          },
        ],
        imgUrlMpX: [{ required: true, message: "不能为空", trigger: "blur" }],
        imgUrlMpY: [{ required: true, message: "不能为空", trigger: "blur" }],
        alias: [{ required: true, message: "不能为空", trigger: "blur" }],
        // deviceSets: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: "",
      },
    };
  },
  components: {
    LoadImg,
  },
  created() {
    // 数据初始化
    this.getData();
    this.getGroupSelected();
    this.getIndustriesSelected();
  },
  methods: {
    getGroupSelected() {
      this.$api.Park.getGroupEnum(null, ["uuids", "park"])
        .then((res) => {
          //console.log(res);
          if (res.code == 0) {
            this.groupList = res.data;
          }
        })
        .catch((err) => {
          //this.loading = false; // 关闭
        });
    },
    getIndustriesSelected() {
      this.$api.Park.getIndustriesEnum(null, ["uuids", "park"])
        .then((res) => {
          //console.log(res);
          if (res.code == 0) {
            this.industriesList = res.data;
          }
        })
        .catch((err) => {
          //this.loading = false; // 关闭
        });
    },
    // 获取企业列表数据
    getData() {
      this.loading = true; // 开启loading...
      this.$api.A_Company.getCompanyList(
        {
          content: {
            name: this.search.name || null,
          },
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
        },
        [null, "system"]
      )
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.list;
            for (let i = 0, length = data.length; i < length; i++) {
              data[i].createDate = timeStamp(data[i].createDate);
            }
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.loading = false; // 关闭
            this.$Message.success("加载完成");
          } else {
            this.loading = false; // 关闭
            this.$Notice.warning({
              title: "加载失败",
              desc: res.message || "请联系管理员",
            });
          }
        })
        .catch((err) => {
          this.loading = false; // 关闭
        });
    },
    // 添加初始化表单
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        name: "", // 企业名称
        imgUrl: "", // 企业厂区图片
        address: "", // 企业地址
        corporate: "", // 企业法人
        contactTel: "", // 企业电话
        logoImgUrl: "",
        alias: "", // 别名
        groupId: "", //所属片区环保所
        industriesId: "", //所属行业
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    // 删除数据操作
    delData() {
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.A_Company.postCompanyDel({ content: { id: id } }, [
          null,
          "system",
        ])
          .then((res) => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: "",
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员",
              });
            }
          })
          .catch((err) => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员",
        });
      }
    },
    // 表格增改操作
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.A_Company.postCompanyAdd({ content: params }, [
              null,
              "system",
            ]).then((res) => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据...",
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员",
                });
              }
            });
          } else {
            this.$api.A_Company.postCompanyEdit({ content: params }, [
              null,
              "system",
            ]).then((res) => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据...",
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员",
                });
              }
            });
          }
        }
      });
    },
    // img上传组件回调
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.imgUrl = url;
    },
    logoImgLoadSuccess(url) {
      this.formValidate.logoImgUrl = url;
    },
    // img删除回调
    imgLoadDel(data) {
      this.formValidate[data] = null;
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
  },
};
</script>